import React from 'react';
import getAppearanceConfig from './helpers/get-appearance-config';
import { APPEARANCES } from './constants';
import animatedIcons from './constants/animated-icons';
import Box from '../box';
import Stack from '../stack';
import Heading from '../heading';
import Paragraph from '../paragraph';
import ActionButton from '../action-button';
import BetaLabel from '../beta-label';
import BlinkingIcon from '../blinking-icon';
const AnimatedBanner = ({
  title,
  description = '',
  appearance = APPEARANCES.default,
  actionButtonLabel = '',
  onActionButtonClick = undefined,
  isBetaLabelShown = false,
  actionButtonHref = '',
  actionButtonTarget = '_blank',
}) => {
  const { actionButtonAppearance, titleAppearance } = getAppearanceConfig(appearance);
  const hasActionButton = Boolean(actionButtonLabel && (onActionButtonClick || actionButtonHref));

  const titleElement =
    typeof title === 'string' ? (
      <Heading type="heading-5" appearance={titleAppearance}>
        {title}
        {isBetaLabelShown && (
          <>
            &nbsp;
            <BetaLabel />
          </>
        )}
      </Heading>
    ) : (
      title
    );

  const descriptionElement =
    typeof description === 'string' ? (
      <Paragraph appearance="medium-emphasis">{description}</Paragraph>
    ) : (
      description
    );

  return (
    <div className={`ws-ui-animated-banner ws-ui-animated-banner--${appearance}`}>
      <div className="ws-ui-animated-banner__decoration">
        {animatedIcons.map(({ key, ...restProps }) => (
          <BlinkingIcon key={key} {...restProps} />
        ))}
      </div>
      <Box
        paddingTop="spacing-s"
        paddingRight="spacing-m"
        paddingBottom="spacing-m"
        paddingLeft="spacing-m"
      >
        <Stack gap="spacing-2-xs">
          <div>
            {titleElement}
            {description && descriptionElement}
          </div>
          {hasActionButton && (
            <div>
              <ActionButton
                appearance={actionButtonAppearance}
                format="solid"
                size="small"
                label={actionButtonLabel}
                onClick={onActionButtonClick}
                href={actionButtonHref}
                target={actionButtonTarget}
              />
            </div>
          )}
        </Stack>
      </Box>
    </div>
  );
};

export default AnimatedBanner;
